import type { HomeState } from '@/lib/cloud/store'

import { useSyncExternalStore } from 'react'
import { homeStore } from '@/lib/cloud/store'

export const useHomeState = (): HomeState => useSyncExternalStore(homeStore.subscribe, homeStore.get, homeStore.getServer)
